import html2canvas from "html2canvas";

function receiptFilename(): string {
  const shareUrl = document
    .querySelector<HTMLMetaElement>('meta[name="stylome:share-url"]')
    ?.content.trim();
  const receiptId = shareUrl?.split("/").filter(Boolean).at(-1);
  const safeId = receiptId?.replace(/[^a-zA-Z0-9_-]/g, "") || "receipt";
  return `stylome-${safeId}.png`;
}

function canvasBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("The browser could not encode the screenshot."));
    }, "image/png");
  });
}

export async function downloadReceiptScreenshot(): Promise<void> {
  const button = document.querySelector<HTMLButtonElement>("#screenshot");
  const receipt = document.querySelector<HTMLElement>("#receipt-capture");
  const status = document.querySelector<HTMLElement>("#action-status");
  if (!button || !receipt || !status) return;

  const label = button.textContent || "Screenshot";
  button.disabled = true;
  button.setAttribute("aria-busy", "true");
  button.textContent = "Rendering…";
  status.textContent = "Preparing the full receipt image.";

  try {
    await document.fonts.ready;
    const canvas = await html2canvas(receipt, {
      backgroundColor: "#f3f0e8",
      logging: false,
      onclone: (clonedDocument) => {
        const clonedCapture =
          clonedDocument.querySelector<HTMLElement>("#receipt-capture");
        if (clonedCapture) clonedCapture.style.background = "#f3f0e8";
      },
      scale: Math.min(window.devicePixelRatio || 1, 2),
      useCORS: true,
    });
    const blob = await canvasBlob(canvas);
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = receiptFilename();
    document.body.append(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(downloadUrl), 1_000);
    status.textContent = "Screenshot downloaded.";
  } catch (error) {
    console.error("Receipt screenshot failed", error);
    status.textContent =
      "Screenshot failed. Your receipt is unchanged; try your browser’s screenshot tool.";
  } finally {
    button.disabled = false;
    button.removeAttribute("aria-busy");
    button.textContent = label;
  }
}

document
  .querySelector<HTMLButtonElement>("#screenshot")
  ?.addEventListener("click", () => void downloadReceiptScreenshot());
